"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import Icon2Bars from "@/app/(components)/generics/Icons/Icon2Bars";
import IconCalendarCheck from "@/app/(components)/generics/Icons/IconCalendarCheck";
import IconCheck from "@/app/(components)/generics/Icons/IconCheck";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { UStyles } from "@/app/utils/UStyles";
import homeStyles from "../../Home.module.css";
import { HOME_CTA_STEPS } from "./CallToCTA.logic";
import styles from "./CallToCTA.module.css";

export type CallToCTAKeys = {
  title1: TKey;
  title2: TKey;
  title3: TKey;
  btn: TKey;
};

type Props = DefaultProps & {
  keys: CallToCTAKeys;
};

export default function CallToCTA(props: Props) {
  const T = useT();
  const { keys } = props;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={UStyles.classNames(homeStyles.title, styles.title)}>
          <span className={styles.iconBars}>
            <Icon2Bars />
          </span>
          {T(keys.title1)}
          <br />
          {T(keys.title2)}
          <br />
          {T(keys.title3)}
        </h2>
      </div>

      <ul className={styles.steps}>
        {HOME_CTA_STEPS.map((step) => (
          <li className={styles.step} key={step}>
            <IconCheck color="var(--color-green-3)" />
            {T(step)}
          </li>
        ))}
      </ul>

      <Button
        min={false}
        params={props.params}
        text={T(keys.btn)}
        isLink={false}
        type={ButtonType.PRIMARY}
        onClick={() => ModalStore.getState().openDemo()}
        beforeIcon={<IconCalendarCheck />}
      />
    </div>
  );
}
